import strings from 'strings';

import { ROLEPLAY_SCENARIOS } from '../constants';

export const COPIES = strings.ai.generators.roleplay;

export const FORM_FIELDS_MAP = {
  Specialty: { key: 'specialty' },
  Subspecialty: { key: 'subspecialty' },
  Title: { key: 'title' },
  Experience: { key: 'experience' },
  Difficulty: { key: 'difficulty' }
};

export const CALL_GOALS = [
  COPIES.scenarios.callCandidate.goals.confirmWilligness,
  COPIES.scenarios.callCandidate.goals.gatherInformation
];

export const JOB_ORDERS_SCENARIO_IDS = ['cold_call_candidate'];

export const JOB_ORDERS_ROLEPLAY_SCENARIOS = ROLEPLAY_SCENARIOS.filter(type => {
  return JOB_ORDERS_SCENARIO_IDS.includes(type.id);
});
